import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import '../../style/invesCarrier.css';
const data = [
    {
        id: 11,
        pro: '三亚育才现代农业产业园',
        src: require('../../assets/zdqyfb.png'),
        map: require('../../assets/zszt_map11.png'),
        coords: '279, 399, 25',
        mCoords: '223, 323, 30',
        type: 'C_F',
        typeText: '仓库、厂房加工',
        area: 21760,
        bArea: 7200,
        av: 'C',
        status: '建设中',
        floor: '1层',
        allFloor: '1层',
        community: '龙密村',
        add: '三亚市育才生态区育才大道',
        name: '杨伟',
        phone: '15607637575'
    },
    {
        id: 22,
        pro: '海垦立才农场公司综合楼',
        src: require('../../assets/zszt_2.jpg'),
        map: require('../../assets/zszt_map22.png'),
        coords: '229, 462, 25',
        mCoords: '183, 374, 30',
        type: 'B_G',
        typeText: '办公、商业铺面',
        area: 3600,
        bArea: 2880,
        av: 'B',
        status: '使用中',
        floor: '3层',
        allFloor: '3层',
        community: '立才居',
        com: 'C_Y',
        add: '三亚市育才生态区育才大道',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        id: 33,
        pro: '仓储用地',
        src: require('../../assets/zdqyfb.png'),
        map: require('../../assets/zszt_map33.png'),
        coords: '270, 452, 25',
        mCoords: '216, 366, 30',
        type: 'C_K',
        typeText: '物流中转、仓储',
        area: 104.68,
        bArea: 104.68,
        av: 'A',
        status: '2023年新增规划项目用地',
        floor: '无楼层',
        allFloor: '无楼层',
        community: '立才居、农场连队片区',
        com: 'Z_Z_C',
        add: '三亚市育才生态区地块编号LCCY-10-01、LCCY-11-01',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        id: 44,
        pro: '那受艺谷项目',
        src: require('../../assets/zszt_4.png'),
        map: require('../../assets/zszt_map44.png'),
        coords: '342, 320, 25',
        mCoords: '273, 259, 30',
        type: 'S_Y',
        typeText: '图书、展览等',
        area: 4500,
        bArea: 3200,
        av: 'B',
        status: '建设中',
        floor: '3层',
        allFloor: '3层',
        community: '那受村',
        com: 'H_X',
        add: '三亚市育才生态区那受村南塔小组',
        name: '彭登泽',
        phone: '15310097161'
    },
    {
        id: 55,
        pro: '农贸市场及停车场',
        src: require('../../assets/zdqyfb.png'),
        map: require('../../assets/zszt_map55.png'),
        coords: '244, 390, 25',
        mCoords: '195, 315, 30',
        type: 'S_Y',
        typeText: '农贸市场及其商铺、停车场',
        area: 7992,
        bArea: 6393.6,
        av: 'C',
        status: '2023年土地储备计划新增项目',
        floor: '无楼层',
        allFloor: '无楼层',
        community: '龙密村',
        com: 'H_X',
        add: '三亚市育才生态区育才大道',
        name: '董成辉',
        phone: '17330893361'
    },
    {
        id: 66,
        pro: '台亚小学',
        src: require('../../assets/zszt_tyxx.jpg'),
        map: require('../../assets/zszt_map66.png'),
        coords: '199, 355, 25',
        mCoords: '159, 287, 30',
        type: 'S_Y',
        typeText: '乡村小学',
        area: 8646.01,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '无楼层',
        allFloor: '两层',
        community: '马脚村',
        com: 'H_X',
        add: '育才镇马脚村委会马脚村',
        name: '',
        phone: ''
    },
    {
        id: 77,
        pro: '那受小学',
        src: require('../../assets/zszt_nsxx.jpg'),
        map: require('../../assets/zszt_map77.png'),
        coords: '298, 333, 25',
        mCoords: '238, 270, 30',
        type: 'S_Y',
        typeText: '乡村小学',
        area: 10090.21,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '无楼层',
        allFloor: '',
        community: '那受村',
        com: 'H_X',
        add: '那受村委会旁',
        name: '',
        phone: ''
    },
    {
        id: 88,
        pro: '那会小学',
        src: require('../../assets/zszt_nhxx.jpg'),
        map: require('../../assets/zszt_map88.png'),
        coords: '377, 218, 25',
        mCoords: '302, 177, 30',
        type: 'S_Y',
        typeText: '乡村小学',
        area: 11739.39,
        bArea: '',
        av: 'C',
        status: '已建成',
        floor: '无楼层',
        allFloor: '',
        community: '那会村',
        com: 'H_X',
        add: '育才生态区管委会以西10公里的那会村委会什盘新村',
        name: '',
        phone: ''
    }
]

function InvesCarrier() {

    const [curCou, setCurCou] = useState(data[3]);
    const [isPhone, setIsPhone] = useState(false);

    useEffect(() => {
        // 手机端设置
        if (window.innerWidth > 768) {
            setIsPhone(false);
        } else {
            setIsPhone(true);
        }
    }, [])

    return (
        <div className="invesCarrier">
            <div className="invesCarrier-pic">
                {
                    data.map(item =>
                        <img
                            key={item.id}
                            id={item.id}
                            className="invesCarrier-pic__img"
                            src={item.map}
                            alt="Planets"
                            useMap="#planetmap"
                            style={{ display: item.id === curCou.id ? 'block' : 'none' }}
                        />
                    )
                }
                <map name="planetmap" id="regionMap">
                    {
                        data.map(item =>
                            <area
                                key={item.id}
                                name="btCountry1"
                                shape="circle"
                                coords={isPhone ? item.mCoords : item.coords}
                                style={{ cursor: 'pointer' }}
                                onMouseMove={() => setCurCou(item)}
                                alt="invesCarrier1"
                            />
                        )
                    }
                </map>
                <Link to='/invesCarriers'>
                    <button className="invesCarrier-pic__btn">查看更多</button>
                </Link>
            </div>
            <div className="invesCarrier-intro">
                <div className="invesCarrier-intro__name">招商载体</div>
                <div className="invesCarrier-intro__text">
                    <p className="invesCarrier-intro__text--row"><span className="info">类型：</span><span className="val">{curCou.typeText}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">所属社区：</span><span className="val">{curCou.community}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">地址：</span><span className="val">{curCou.add}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">可供招商面积(㎡)：</span><span className="val">{curCou.bArea}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">总层数：</span><span className="val">{curCou.allFloor}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">建筑面积(㎡)：</span><span className="val">{curCou.area}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">建筑情况：</span><span className="val">{curCou.status}</span></p>
                    <p className="invesCarrier-intro__text--row"><span className="info">联系人：</span><span className="val">{curCou.name} {curCou.phone}</span></p>
                </div>
                <img className="invesCarrier-intro__pic" src={curCou.src} alt="美丽乡村" />
            </div>
        </div>
    );
}

export default InvesCarrier;
